import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "grasp-input__wrapper" };
const _hoisted_2 = { style: { "display": "flex", "align-items": "center" } };
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = { key: 2 };
const _hoisted_6 = { class: "file-upload__label" };
const _hoisted_7 = { class: "base-upload__delete-btn" };
const _hoisted_8 = {
    key: 2,
    class: "grasp-input__append"
};
import { File, Upload, XCircle } from 'lucide-vue-next';
// import { computed } from 'vue';
import { inject, reactive, ref, computed } from "vue";
import DomUtil from "@/utils/dom.util";
import { ConversationMediaType } from "@/types/ConversationTypes";
export default /*#__PURE__*/ _defineComponent({
    __name: '_BaseUpload',
    props: {
        modelValue: {
            required: true,
        },
        buttonText: String,
        bordered: {
            default: true,
            type: Boolean
        },
        disallowedExtensions: {
            default() { return ['exe', 'php5', 'php', 'cer', 'jsp']; },
            type: Array,
        }
    },
    emits: ['update:modelValue', 'attachmentPanelOpened', 'attachmentPanelClosed'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const toast = inject('toast');
        const t = inject('i18n');
        const fileInput = ref(null);
        const pickFile = () => {
            fileInput.value.click();
        };
        const data = reactive({
            fileUploadPreview: null
        });
        const handleFileUpload = async (event) => {
            let f = fileInput.value.files[0];
            let tp = null;
            // check extension
            const ext = f.name.match(/.([^.]+)$/)[1];
            if (props.disallowedExtensions.includes(ext)) {
                toast.show(t('common.errors.upload_file_type_disallowed'), { position: 'bottom', duration: 4000 });
                return;
            }
            else if (f.size > 5242880) {
                // check file size limit
                toast.show(t('common.errors.upload_too_large'), { position: 'bottom', duration: 4000 });
                return;
            }
            switch (f.type) {
                case 'image/gif':
                case 'image/png':
                case 'image/jpeg':
                case 'image/webp':
                    tp = ConversationMediaType.IMAGE;
                    break;
                case 'video/mp4':
                    tp = ConversationMediaType.VIDEO;
                    break;
                default:
                    tp = null;
            }
            data.fileUploadPreview = {
                name: f.name,
                type: tp,
                url: URL.createObjectURL(f),
                file: f
            };
            emits('attachmentPanelOpened');
            // reset value to let @change trigger again even when same attachment file has been selected
            // https://stackoverflow.com/questions/19643265/second-use-of-input-file-doesnt-trigger-onchange-anymore
            event.target.value = '';
        };
        const removeUpload = () => {
            data.fileUploadPreview = null;
            emits('attachmentPanelClosed');
            DomUtil.focusConversationInputField();
        };
        const isImage = computed(() => {
            return ConversationMediaType.IMAGE;
        });
        const isVideo = computed(() => {
            return ConversationMediaType.VIDEO;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (data.fileUploadPreview)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["__row anim__slide-from-bottom", { '--active-uploads': data.fileUploadPreview }])
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            (data.fileUploadPreview.type === _unref(isImage))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "base-upload__preview-asset",
                                    src: data.fileUploadPreview.url
                                }, null, 8, _hoisted_3))
                                : (data.fileUploadPreview.type === _unref(isVideo))
                                    ? (_openBlock(), _createElementBlock("video", {
                                        key: 1,
                                        class: "base-upload__preview-asset",
                                        src: data.fileUploadPreview.url
                                    }, null, 8, _hoisted_4))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createVNode(_unref(File), {
                                            class: "file-icon",
                                            stroke: "var(--color-background-grayer)"
                                        }),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(data.fileUploadPreview.name), 1)
                                    ])),
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(_unref(XCircle), {
                                    color: "var(--primary-color)",
                                    onClick: removeUpload
                                })
                            ])
                        ])
                    ], 2))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        ref: "file",
                        class: "grasp-input__upload-btn btn__primary",
                        onClickPassive: pickFile,
                        "aria-label": "Upload attachment",
                        role: "button",
                        tabindex: "0"
                    }, [
                        _createVNode(_unref(Upload), {
                            size: "18",
                            class: "btn__icon"
                        }),
                        _createTextVNode(" " + _toDisplayString(__props.buttonText) + " ", 1),
                        _createElementVNode("input", {
                            ref_key: "fileInput",
                            ref: fileInput,
                            type: "file",
                            style: { "display": "none" },
                            onChange: handleFileUpload
                        }, null, 544)
                    ], 544)),
                (_ctx.$slots['append'])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _renderSlot(_ctx.$slots, "append")
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
